import { render, staticRenderFns } from "./excel-template.vue?vue&type=template&id=72a4852a"
import script from "./excel-template.vue?vue&type=script&lang=ts"
export * from "./excel-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports